import { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Breadcrumb, Button, Card, Dropdown, Form, Icon, Menu } from 'semantic-ui-react';
import PageContainer from '../../common/PageContainer';
import * as selectors from '../../../redux/selectors';
import * as actions from '../../../redux/actions';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import { TextField } from '../../common/FormFields';
import { DateInput } from 'semantic-ui-calendar-react';
import { addInvoiceValidationSchema } from '../invoicing.constants';
import * as moment from 'moment';

const AddInvoicePage = ({ user, sites, getSites, getUsers, users, editors, addInvoice, history }) => {
  const types = ['Article', 'Promoted Content', 'Other'].map(k => ({
    key: k,
    text: k,
    value: k,
  }));

  useEffect(() => {
    const currentYear = moment().year();
    const startYear = currentYear;

    const temp = [];

    for (let index = 0; index < 1; index++) {
      temp.push(startYear + index);
    }
  }, []);

  const initialValues = {
    editorId: '',
    contributorId: user.id,
    description: '',
    amount: 0,
    date: '',
    type: 'Article',
    siteId: '',
    isApproved: false,
    isDeleted: false,
    editorComments: '',
    month: moment().month(),
    year: moment().year(),
  };

  const handleSave = data => {
    addInvoice(data);
  };

  return (
    <PageContainer>
      <Breadcrumb>
        <Breadcrumb.Section>Invoices</Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section>
          <Link to="/my-invoices" style={{ padding: 0, margin: 0 }}>
            My Invoices
          </Link>
        </Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section>New Invoice</Breadcrumb.Section>
      </Breadcrumb>

      <Formik initialValues={initialValues} onSubmit={handleSave} validationSchema={addInvoiceValidationSchema}>
        {formik => (
          <>
            <Menu borderless>
              <Menu.Item header>
                <Icon name="file outline" />
                New Invoice
              </Menu.Item>
            </Menu>

            <Card fluid>
              <Card.Content>
                <Form>
                  <Form.Field error={Boolean(formik.errors.siteId)}>
                    <label htmlFor="site">City</label>
                    <Dropdown
                      fluid
                      search
                      selection
                      clearable
                      options={sites}
                      id="siteId"
                      data-testid="siteId"
                      label="Site"
                      name="siteId"
                      value={formik.values.siteId}
                      onChange={(e, d) => formik.setFieldValue(d.name, d.value)}
                    />
                  </Form.Field>

                  <Form.Field error={Boolean(formik.errors.contributorId)}>
                    <label htmlFor="style">Contributor</label>
                    <Dropdown
                      fluid
                      search
                      selection
                      clearable
                      disabled={!user.roles.find(role => role.name === 'admin' || role.name === 'editor')}
                      options={users}
                      id="contributorId"
                      data-testid="contributorId"
                      label="Contributor"
                      name="contributorId"
                      value={formik.values.contributorId}
                      onChange={(e, d) => formik.setFieldValue(d.name, d.value)}
                    />
                  </Form.Field>

                  <Form.Field error={Boolean(formik.errors.editorId)}>
                    <label htmlFor="style">Assigned By</label>
                    <Dropdown
                      fluid
                      search
                      selection
                      clearable
                      options={editors}
                      id="editorId"
                      data-testid="editorId"
                      label="Assigned By"
                      name="editorId"
                      value={formik.values.editorId}
                      onChange={(e, d) => formik.setFieldValue(d.name, d.value)}
                    />
                  </Form.Field>

                  <Form.Field error={Boolean(formik.errors.type)}>
                    <label htmlFor="type">Type</label>
                    <Dropdown
                      fluid
                      search
                      selection
                      clearable
                      options={types}
                      id="type"
                      data-testid="type"
                      label="Type"
                      name="type"
                      value={formik.values.type}
                      onChange={(e, d) => formik.setFieldValue(d.name, d.value)}
                    />
                  </Form.Field>

                  <TextField
                    name="description"
                    label="Description"
                    formik={formik}
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    error={formik.touched.description && Boolean(formik.errors.description)}
                    errorMessage={formik.errors.description}
                  />

                  <Form.Field error={Boolean(formik.errors.date)}>
                    <label>Date completed</label>
                    <DateInput
                      name="date"
                      closable={true}
                      popupPosition="bottom center"
                      placeholder="Date completed"
                      iconPosition="left"
                      dateFormat="YYYY-MM-DD"
                      value={formik.values.date}
                      onChange={(e, { value }) => formik.setFieldValue('date', value)}
                    />
                  </Form.Field>

                  <TextField
                    name="amount"
                    label="Amount"
                    formik={formik}
                    value={formik.values.amount}
                    onChange={formik.handleChange}
                    error={formik.touched.amount && Boolean(formik.errors.amount)}
                    errorMessage={formik.errors.amount}
                  />
                </Form>
              </Card.Content>

              <Card.Content extra>
                <Button
                  content="Save & Add Another"
                  icon="save"
                  positive
                  type="submit"
                  onClick={() => {
                    formik.handleSubmit();
                    setInterval(() => {
                      if (!formik.isSubmitting && formik.isValid) {
                        window.location.reload();
                      }
                    }, 500);
                  }}
                />
                <Button
                  content="Save"
                  icon="save"
                  positive
                  type="submit"
                  onClick={() => {
                    formik.handleSubmit();
                    history.push('/my-invoices');
                  }}
                />
              </Card.Content>
            </Card>
          </>
        )}
      </Formik>
    </PageContainer>
  );
};

const mapStateToProps = state => ({
  invoices: selectors.getAllInvoices(state),
  user: selectors.getUser(state),
  sites: selectors.admin.siteOptionsDetail(state),
  users: selectors.getUserOptions(state),
  editors: selectors.getEditors(state),
});

const mapDispatchToProps = dispatch => ({
  addInvoice: bindActionCreators(actions.invoices.addInvoice, dispatch),
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
  getUsers: bindActionCreators(actions.admin.getUsers, dispatch),
  getInvoices: bindActionCreators(actions.invoices.getInvoices, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddInvoicePage);
